import Admin from '../pages/adminHome/AdminHome';
import { clause4 } from './admin/clause4';
import { clause10 } from './admin/clause10';
import { clause7 } from './admin/clause7';
import { clause8 } from './admin/clause8';
import { other } from './admin/other';
import { productions } from './admin/production';
import { TagList } from '../pages/tagGenerator';
import { salesAndRM } from './admin/salesAndRm';
import { salaryManagement } from './admin/SalaryManagement';
import { clause3 } from './admin/clause3';
import { Clause19Home } from '../pages/clause19';
import { Clause17Home } from '../pages/clause17';
import { Clause18Home } from '../pages/clause18';
import { Clause16Home } from '../pages/clause16';
import { Clause14Home } from '../pages/clause14';
import { Clause15Home } from '../pages/clause15';
import { Clause13Home } from '../pages/clause13';
import { Clause12Home } from '../pages/clause12';
import { Clause11Home } from '../pages/clause11';
import { Clause2Home } from '../pages/clause2';
import { Clause1Home } from '../pages/clause1';
import { Clause3Home } from '../pages/clause3';
import { Clause6Home } from '../pages/clause6';
import { Clause9Home } from '../pages/clause9';
interface routes {
  path: string;
  element: JSX.Element;
  errorElement?: string;
}

export const IndexAdmin: routes[] = [
  {
    path: 'home',
    element: <Admin />,
  },
  {
    path: 'tagList',
    element: <TagList />,
  },
  {
    path: 'clause1',
    element: <Clause1Home />,
  },
  {
    path: 'clause2',
    element: <Clause2Home />,
  },
  {
    path: 'clause6',
    element: <Clause6Home />,
  },
  {
    path: 'clause9',
    element: <Clause9Home />,
  },
  {
    path: 'clause11',
    element: <Clause11Home />,
  },
  {
    path: 'clause12',
    element: <Clause12Home />,
  },
  {
    path: 'clause13',
    element: <Clause13Home />,
  },
  {
    path: 'clause14',
    element: <Clause14Home />,
  },
  {
    path: 'clause15',
    element: <Clause15Home />,
  },
  {
    path: 'clause16',
    element: <Clause16Home />,
  },
  {
    path: 'clause17',
    element: <Clause17Home />,
  },
  {
    path: 'clause18',
    element: <Clause18Home />,
  },
  {
    path: 'clause19',
    element: <Clause19Home />,
  },
  ...productions,
  ...clause3,
  ...clause4,
  ...clause7,
  ...clause8,
  ...clause10,
  ...other,
  ...salesAndRM,
  ...salaryManagement,
];
